export default {
  "about": "A propos",
  "about_title": "À propos de nous",
  "access_secret": "Secret d'accès",
  "access_token": "Jeton d'accès",
  "accessibility_animations": "Animations",
  "accessibility_contrast": "Contraste",
  "accessibility_font_size": "Taille de police",
  "accessibility_title": "Accessibilité",
  "actions": "Actions",
  "active": "Actif",
  "active_ads": "Annonces actives",
  "active_campaigns": "Campagnes actives",
  "ad_code_placeholder": "<script>...</script> ou code d'emplacement AdSense",
  "ad_format": "Format de l'annonce",
  "ad_formats": "Formats d",
  "ad_management": "Gestion des annonces",
  "ad_position_settings": "Paramètres de la position des annonces",
  "ad_price_list": "Liste des tarifs des annonces",
  "ad_pricing_formats_campaigns": "Tarification, formats, campagnes et suivi",
  "add": "Ajouter",
  "add_api_keys": "Ajouter des clés API dans l'onglet Configuration",
  "address": "Adresse",
  "admin": "Admin",
  "adminPanel": "Panneau d'administration",
  "admin_ab_testing_title": "Test A/B",
  "admin_accent": "Accent",
  "admin_accent_color": "Couleur d'accent",
  "admin_action": "Action",
  "admin_activate": "Activer",
  "admin_active_feeds": "Flux actifs",
  "admin_active_label": "ACTIF",
  "admin_active_now": "Actif maintenant",
  "admin_active_subscribers": "Abonnés actifs",
  "admin_ad_performance": "Performance des annonces",
  "admin_add_feed": "Ajouter un flux",
  "admin_add_tag": "Ajouter une étiquette",
  "admin_admins": "Admins",
  "admin_advertisements": "Publicités",
  "admin_advertiser_email": "Email de l'annonceur",
  "admin_advertiser_name": "Nom de l'annonceur",
  "admin_affiliate_links": "Liens Affiliés",
  "admin_ai_content_title": "Traitement de contenu IA",
  "admin_ai_prompt_settings": "Paramètres de l'invite & du modèle IA",
  "admin_analytics_title": "Analytique",
  "admin_api_latency": "Latence API",
  "admin_api_server": "Serveur API",
  "admin_article_actions": "Actions",
  "admin_article_category": "Catégorie",
  "admin_article_published": "Publié",
  "admin_article_selector": "Sélecteur d'article (CSS, par ex. article.news)",
  "admin_article_views": "Vues",
  "admin_articles_count": "Articles",
  "admin_articles_title": "Articles",
  "admin_author_change_failed": "Le changement d'auteur a échoué.",
  "admin_authors_title": "Auteurs",
  "admin_auto": "AUTO",
  "admin_auto_save_draft": "Sauvegarde automatique en brouillon",
  "admin_avg_seo_score": "Score SEO moyen",
  "admin_bio": "Bio",
  "admin_blog_manage": "Gérer les articles de blog avec un éditeur de contenu enrichi",
  "admin_blog_title": "Blog",
  "admin_brand_theme": "Marque & Thème",
  "admin_branding_desc": "Personnaliser l'apparence du site (Administrateur Système Seulement)",
  "admin_branding_title": "Module de Rebranding",
  "admin_breaking_ticker": "Ticker des Dernières Nouvelles",
  "admin_browser": "Navigateur",
  "admin_browsers": "Navigateurs",
  "admin_bug_reports": "Rapports de bugs",
  "admin_bulk_delete_failed": "Échec de la suppression en masse.",
  "admin_bulk_operations": "Opérations en masse",
  "admin_categories_grid": "Grille des Catégories",
  "admin_choose_gallery": "Choisir depuis la galerie",
  "admin_churn_prediction": "Prédiction de Churn",
  "admin_classic_portal": "Portail de Nouvelles Classique",
  "admin_classifieds": "Petites annonces",
  "admin_clear_log": "Effacer le journal",
  "admin_click_button": "Cliquez sur le bouton",
  "admin_collection_stats": "Statistiques de collection",
  "admin_color_scheme": "Schéma de couleurs",
  "admin_columnist": "Chroniqueur",
  "admin_comments": "Commentaires",
  "admin_competitor_monitoring": "Suivi des Concurrents",
  "admin_confirm_action": "Êtes-vous sûr ?",
  "admin_content_calendar_title": "Calendrier de Contenu",
  "admin_content_filter": "Termes de filtrage de contenu",
  "admin_content_stats": "Statistiques de contenu",
  "admin_contributor": "Contributeur",
  "admin_coordinates": "Coordonnées",
  "admin_copy_ip": "Copier l'adresse IP",
  "admin_copy_text": "Copier",
  "admin_core_services": "Services principaux",
  "admin_countries": "Pays",
  "admin_cpc": "CPC (EUR)",
  "admin_crawl_now": "Explorer maintenant",
  "admin_create_author": "Créer un auteur",
  "admin_create_manage_promo": "Créer et gérer les codes promotionnels",
  "admin_create_voucher": "Créer un bon",
  "admin_custom_meta": "Méta personnalisée",
  "admin_dashboard_title": "Tableau de bord",
  "admin_database": "Base de données",
  "admin_db_backup": "Sauvegarde de la Base de Données",
  "admin_db_latency": "Latence DB",
  "admin_db_name": "Nom de la base de données",
  "admin_db_size": "Taille DB",
  "admin_default": "PAR DÉFAUT",
  "admin_default_language": "Langue par défaut",
  "admin_device": "Appareil",
  "admin_devices": "Appareils",
  "admin_discount": "Remise",
  "admin_disk_usage": "Utilisation du disque",
  "admin_docs_api_ref": "Référence API",
  "admin_docs_download_pdf": "Télécharger le PDF",
  "admin_docs_faq": "FAQ",
  "admin_docs_getting_started": "Commencer",
  "admin_docs_implemented": "Implémenté",
  "admin_docs_no_pages": "Pas encore de pages de documentation",
  "admin_docs_order": "Ordre",
  "admin_docs_title": "Documentation",
  "admin_doktor_earnings": "Gains Doktor",
  "admin_draft_articles": "Articles en brouillon",
  "admin_dynamic_pricing": "Tarification Dynamique",
  "admin_edit_in_cms": "Éditer dans le CMS",
  "admin_editor_role": "Éditeur",
  "admin_export_csv": "Exporter en CSV",
  "admin_favicon": "Favicon",
  "admin_feed_crawler": "Aspirateur de flux",
  "admin_feed_name": "Nom du flux",
  "admin_feed_url": "URL du flux",
  "admin_feeds_title": "Flux RSS",
  "admin_file": "Fichier",
  "admin_fixed_amount": "Montant fixe",
  "admin_frozen": "Gelé",
  "admin_full_name": "Nom complet",
  "admin_general": "Général",
  "admin_google_search_console": "Google Search Console",
  "admin_grade": "Note",
  "admin_health_title": "Vérification de santé",
  "admin_high_leads": "Leads de haute valeur",
  "admin_import_title": "Plateforme d'Importation Croatia Times",
  "admin_index_now": "IndexNow",
  "admin_integrations": "Intégrations",
  "admin_job_postings": "Offres d'emploi",
  "admin_joined": "Rejoint",
  "admin_keywords": "Mots-clés",
  "admin_landing_title": "Pages d'atterrissage",
  "admin_last_submissions": "Dernières soumissions",
  "admin_live_analytics": "Analytique en direct",
  "admin_live_analytics_title": "Analytique en direct",
  "admin_llm_model": "Modèle LLM",
  "admin_manage_feeds": "Gérer les flux",
  "admin_mass_management": "Gestion massive des articles",
  "admin_max_articles": "Articles max.",
  "admin_media_storage": "Stockage média",
  "admin_memory": "Mémoire",
  "admin_menu_manager": "Gestionnaire de menu",
  "admin_meta_description": "Meta description",
  "admin_monetization_title": "Tableau de bord de monétisation",
  "admin_mysql_db": "Base de données MySQL",
  "admin_mysql_host": "Hôte MySQL",
  "admin_nav_ab_testing": "Test A/B",
  "admin_nav_ads": "Gestion des publicités",
  "admin_nav_ads_report": "Rapport publicitaire",
  "admin_nav_adsense": "Paramètres AdSense",
  "admin_nav_advanced_analytics": "Analyses avancées",
  "admin_nav_affiliates": "Liens d'affiliation",
  "admin_nav_ai_content": "Traitement de contenu IA",
  "admin_nav_amp": "AMP & Google Discover",
  "admin_nav_analytics": "Analyses",
  "admin_nav_analytics_ai": "Analyses & IA",
  "admin_nav_articles": "Articles",
  "admin_nav_audit_log": "Journal d'audit",
  "admin_nav_authors": "Auteurs",
  "admin_nav_blog": "Blog",
  "admin_nav_branding": "Rebranding",
  "admin_nav_breaking_news": "Dernières / Flash Infos",
  "admin_nav_bulk_operations": "Opérations en masse",
  "admin_nav_categories": "Catégories",
  "admin_nav_chat_sessions": "Sessions de chat",
  "admin_nav_churn_prediction": "Prévision du taux de désabonnement",
  "admin_nav_classifieds": "Petites annonces",
  "admin_nav_comments": "Commentaires",
  "admin_nav_competitor_monitoring": "Surveillance des concurrents",
  "admin_nav_content": "Contenu",
  "admin_nav_content_calendar": "Calendrier de contenu",
  "admin_nav_county_map": "Carte du comté",
  "admin_nav_crypto": "Widget Crypto",
  "admin_nav_dashboard": "Tableau de bord",
  "admin_nav_db_backup": "Base de données",
  "admin_nav_docs": "Documentation",
  "admin_nav_doktor_earnings": "Gains Doktor",
  "admin_nav_duplicate_detection": "Détection de doublons",
  "admin_nav_editorial": "Éditorial",
  "admin_nav_editorial_workflow": "Flux de travail éditorial",
  "admin_nav_email_campaigns": "Campagnes par e-mail",
  "admin_nav_feeds": "Flux RSS",
  "admin_nav_finance": "Finance",
  "admin_nav_health": "État du système",
  "admin_nav_heatmaps": "Carte thermique de lecture",
  "admin_nav_import": "Importer",
  "admin_nav_invoices": "Factures",
  "admin_nav_job_ads": "Annonces d'emploi",
  "admin_nav_landing_pages": "Pages de destination",
  "admin_nav_live_analytics": "Analyses en direct",
  "admin_nav_management": "Gestion",
  "admin_nav_marketing": "Marketing",
  "admin_nav_media": "Médias",
  "admin_nav_menu_manager": "Gestionnaire de menu",
  "admin_nav_micropayments": "Micro-paiements",
  "admin_nav_monetization": "Monétisation",
  "admin_nav_newsletter": "Newsletter",
  "admin_nav_newsletter_digest": "Résumé de la newsletter",
  "admin_nav_pages": "Pages",
  "admin_nav_payments": "Paiements",
  "admin_nav_performance_forecast": "Prévision de performance",
  "admin_nav_photo_verification": "Vérification photo",
  "admin_nav_portal_toggle": "Gestion du portail",
  "admin_nav_portals": "Portails",
  "admin_nav_pricing": "Tarification",
  "admin_nav_promo_codes": "Codes promo",
  "admin_nav_push_notifications": "Notifications Push",
  "admin_nav_quizzes": "Quiz",
  "admin_nav_recommendations": "Recommandations de contenu",
  "admin_nav_reports": "Rapports de contenu",
  "admin_nav_sanitization": "Assainissement de contenu",
  "admin_nav_scheduler": "Planificateur de contenu",
  "admin_nav_security": "Sécurité",
  "admin_nav_seo_dashboard": "Tableau de bord SEO",
  "admin_nav_seo_distribution": "SEO & Distribution",
  "admin_nav_series": "Séries d'articles",
  "admin_nav_settings": "Paramètres",
  "admin_nav_social": "Réseaux sociaux",
  "admin_nav_social_scheduler": "Planificateur social",
  "admin_nav_sponsored": "Sponsorisé",
  "admin_nav_sponsored_marketplace": "Place de marché sponsorisée",
  "admin_nav_subscriptions": "Abonnements",
  "admin_nav_surveys": "Sondages",
  "admin_nav_syndication": "API de syndication",
  "admin_nav_system": "Système",
  "admin_nav_tips": "Pourboires / Dons",
  "admin_nav_translations": "Traductions",
  "admin_nav_ugc_review": "Contenu citoyen",
  "admin_nav_users": "Utilisateurs",
  "admin_nav_users_subscriptions": "Utilisateurs & Abonnements",
  "admin_nav_versioning": "Historique des versions",
  "admin_nav_vibeposao": "Times Posao Portal",
  "admin_nav_vouchers": "Bons / Réductions",
  "admin_nav_widgets": "Widgets / Catalogues",
  "admin_new_author_name": "Nouveau nom d'auteur...",
  "admin_new_post": "Nouvel article",
  "admin_no_data": "Pas de données disponibles",
  "admin_no_icon": "Pas d'icône",
  "admin_no_logo": "Pas de logo",
  "admin_no_pending_reports": "Aucun rapport en attente",
  "admin_no_published_articles": "Aucun article publié trouvé",
  "admin_password_field": "Mot de passe",
  "admin_performance_forecast": "Prévision des Performances",
  "admin_photo_verification": "Vérification de Photo",
  "admin_plan": "Forfait",
  "admin_platform_audit": "Audit de la Plateforme",
  "admin_portal_toggle": "Gestion du Portail",
  "admin_premium_users": "Utilisateurs premium",
  "admin_primary": "Primaire",
  "admin_published_articles": "Articles publiés",
  "admin_published_today": "Publié aujourd'hui",
  "admin_quick_actions": "Actions rapides",
  "admin_recent_articles": "Articles récents",
  "admin_role_change_failed": "Échec de la mise à jour du rôle.",
  "admin_search_placeholder": "Rechercher dans l'administration...",
  "admin_secondary": "Secondaire",
  "admin_seo_desc": "Optimisation de contenu, gestion GSC & sitemap",
  "admin_seo_title": "Tableau de bord SEO",
  "admin_service_requests": "Demandes de Service",
  "admin_set_category": "Définir la catégorie",
  "admin_set_featured": "Définir en vedette",
  "admin_settings_saved": "Paramètres sauvegardés",
  "admin_settings_title": "Paramètres",
  "admin_short_desc": "Brève description",
  "admin_site_identity": "Identité du site",
  "admin_site_logo": "Logo du site",
  "admin_site_settings": "Paramètres du site",
  "admin_sponsored_marketplace": "Marché Sponsorisé",
  "admin_sponsored_title": "Articles Sponsorisés",
  "admin_surveys_title": "Sondages",
  "admin_system_status": "État du système",
  "admin_table_header_actions": "Actions",
  "admin_table_header_date": "Date",
  "admin_table_header_email": "Email",
  "admin_table_header_name": "Nom",
  "admin_table_header_status": "Statut",
  "admin_thumbnail_settings_saved": "Paramètres de la miniature enregistrés",
  "admin_top_articles_views": "Articles populaires par vues",
  "admin_total_articles": "Articles totaux",
  "admin_total_users": "Utilisateurs totaux",
  "admin_total_views": "Vues totales",
  "admin_ugc_review": "Revue de UGC",
  "admin_username": "Nom d'utilisateur",
  "admin_users_title": "Utilisateurs",
  "admin_version_history": "Historique des Versions",
  "admin_view_health_report": "Voir le rapport complet de santé",
  "admin_write_new_article": "Écrire un nouvel article",
  "adsense_client_id": "ID Client AdSense",
  "adsense_enable_disable": "Activer/désactiver tous les formats publicitaires automatisés",
  "adsense_global_toggle": "Activation/Désactivation Globale AdSense",
  "adsense_script_code": "Code du script AdSense",
  "adsense_settings": "Paramètres AdSense & positions des annonces",
  "advertise_contact_sales": "Contacter les Ventes",
  "advertise_get_started": "Commencer",
  "advertise_reach_audience": "Rejoindre notre public",
  "advertise_title": "Annoncez avec Nous",
  "advertiser": "Annonceur",
  "advertiser_analytics": "Analyses de l'annonceur",
  "advertiser_email": "Email de l'annonceur",
  "advertising": "Publicite",
  "advertising_cookies": "Cookies publicitaires",
  "affiliate_title": "Programme d'Affiliation",
  "ago": "il y a",
  "ai_image_prompt": "Invite de l'image AI",
  "all": "Tous",
  "all_categories": "Toutes les catégories",
  "all_jobs": "Toutes les offres",
  "all_rights": "Tous droits reserves",
  "all_status": "Tous les statuts",
  "all_types": "Tous types",
  "alpha": "Alpha",
  "alreadyHaveAccount": "Vous avez déjà un compte ?",
  "already_have_account": "Deja un compte?",
  "analytics": "Analytique",
  "analytics_cookies": "Cookies analytiques",
  "api_key": "Clé API",
  "api_secret": "Secret API",
  "applications": "Candidatures",
  "apply": "Appliquer",
  "apply_now": "Postuler",
  "approve": "Approuver",
  "approved": "Approuvé",
  "archive": "Archiver",
  "archived": "Archivé",
  "article_content": "Contenu de l'article",
  "article_title": "Titre de l'article...",
  "article_views": "Vues",
  "author": "Auteur",
  "auto_posting": "Publication automatique et intégrations sociales",
  "auto_share_articles": "Partager automatiquement les articles publiés sur les plateformes connectées",
  "avg_ctr": "CTR moyen",
  "back": "Retour",
  "basic": "Basique",
  "be_respectful": "Soyez respectueux et courtois envers les autres utilisateurs et les sujets des articles",
  "beta": "Bêta",
  "book_ad": "Réserver une annonce",
  "booking_details": "Détails de la réservation",
  "breaking": "FLASH INFO",
  "bug_description": "Description du bug",
  "business": "Affaires",
  "business_account_id": "ID du compte entreprise",
  "buyer": "Acheteur",
  "campaign_details": "Détails de la campagne",
  "campaigns": "Campagnes",
  "cancel": "Annuler",
  "caption": "Légende",
  "categories": "Categories",
  "category": "Catégorie",
  "category_distribution": "Répartition par catégorie",
  "category_push_subscribers": "Abonnés push par catégorie",
  "chatbot_placeholder": "Tapez un message...",
  "chatbot_send": "Envoyer",
  "chatbot_title": "Assistant de Chat",
  "choose_plan": "Choisissez votre plan",
  "city": "Ville",
  "classifieds": "Petites annonces",
  "classifieds_title": "Annonces",
  "clear": "Effacer",
  "click_rate": "Taux de clics",
  "click_url": "URL de clic (destination)",
  "clicks": "Clics",
  "client_id": "ID client",
  "client_secret": "Secret client",
  "close": "Fermer",
  "code": "Code",
  "commenting_rules": "Règles de commentaires",
  "comments": "Commentaires",
  "companies": "Entreprises",
  "company": "Entreprise",
  "compose_social_post": "Rédiger un post social",
  "configure": "Configurer",
  "configure_position": "Configurez chaque position avec une image de bannière personnalisée ou un code publicitaire",
  "confirm": "Confirmer",
  "confirm_delete": "Êtes-vous sûr de vouloir supprimer ?",
  "confirm_password": "Confirmer le mot de passe",
  "congratulations": "Félicitations",
  "contact": "Contact",
  "contact_title": "Contact",
  "contact_us": "Contactez-nous",
  "content": "Contenu",
  "cookies": "Cookies",
  "cookies_title": "Politique de cookies",
  "copy": "Copier",
  "copyright": "Droits d'auteur",
  "copyright_notice": "Droits d'auteur",
  "count": "Compter",
  "country": "Pays",
  "cpm": "CPM",
  "create": "Creer",
  "create_first_ad": "Créez votre première annonce",
  "crypto_change_24h": "Changement 24h",
  "crypto_market_cap": "Capitalisation boursière",
  "crypto_price": "Prix",
  "crypto_widget_title": "Crypto",
  "ctr": "CTR",
  "culture": "Culture",
  "current_plan": "Plan actuel",
  "custom_ad_code": "Code publicitaire personnalisé",
  "custom_banner_url": "URL de bannière personnalisée",
  "custom_range": "Plage personnalisée",
  "daily_budget": "Budget quotidien",
  "daily_performance": "Performance quotidienne",
  "dark_mode": "Mode sombre",
  "data_viz_title": "Visualisation des Données",
  "date": "Date",
  "dating_add_video": "Ajoutez une courte vidéo pour que les correspondances potentielles puissent mieux vous connaître",
  "dating_block": "Bloquer",
  "dating_boosts": "Boosts",
  "dating_city": "Ville",
  "dating_next": "Suivant",
  "dating_personality_quiz": "Quiz de personnalité",
  "dating_quiz_completed": "Quiz de personnalité complété",
  "dating_users": "Utilisateurs",
  "dating_verify_identity": "Vérifiez que vous êtes une vraie personne",
  "dating_voice_message": "Message vocal",
  "days": "jours",
  "delete": "Supprimer",
  "delete_failed": "Échec de la suppression.",
  "deleted_successfully": "Supprimé avec succès",
  "deprecated": "Obsolète",
  "describe_thumbnail": "Décrivez l'image miniature à générer...",
  "description": "Description",
  "deselect_all": "Tout désélectionner",
  "desktop": "Ordinateur de bureau",
  "details": "Détails",
  "dimensions": "Dimensions",
  "disabled": "Désactivé",
  "dismiss": "Ignorer",
  "documentation": "Documentation",
  "doktor_add_document": "Ajouter un Document",
  "doktor_biography": "Biographie",
  "doktor_birth_date": "Date de Naissance",
  "doktor_chat": "Chat",
  "doktor_control_date": "Date de Contrôle",
  "doktor_date": "Date",
  "doktor_diagnosis": "Diagnostic",
  "doktor_enter_name_specialization": "Entrez un nom et au moins une spécialisation",
  "doktor_enter_patient_name": "Entrez le nom du patient",
  "doktor_license_number": "Numéro de Licence",
  "doktor_panel": "Panneau du Médecin",
  "doktor_patient_name": "Nom du Patient",
  "doktor_text_min_chars": "Le texte doit comporter au moins 50 caractères",
  "doktor_waiting_room": "Salle d'Attente",
  "dont_have_account": "Pas de compte?",
  "download": "Télécharger",
  "draft": "Brouillon",
  "duplicate": "Dupliquer",
  "duration_days": "Durée (jours)",
  "economy": "Économie",
  "edit": "Modifier",
  "electronics": "Électronique",
  "email": "Email",
  "email_address": "Adresse e-mail",
  "email_campaigns": "Campagnes d'emailing",
  "email_clicks": "Clics dans l",
  "email_content": "Contenu de l'email...",
  "email_opens": "Ouvertures d",
  "email_placeholder": "Votre adresse email",
  "email_subject": "Objet de l'email",
  "employer": "Employeur",
  "enabled": "Activé",
  "end_date": "Date de fin",
  "enter_advertiser_email": "Entrez votre email d'annonceur...",
  "enter_email_to_view": "Entrez votre email d'annonceur ci-dessus pour voir les performances de votre campagne",
  "entertainment": "Divertissement",
  "error": "Erreur",
  "error_deleting": "Erreur de suppression",
  "error_generating_digest": "Erreur lors de la génération du résumé",
  "error_loading": "Erreur de chargement",
  "error_saving": "Erreur lors de l'enregistrement",
  "error_saving_settings": "Erreur de sauvegarde",
  "error_sending": "Erreur d'envoi",
  "error_uploading": "Erreur de téléversement",
  "error_uploading_photo": "Échec du téléchargement de la photo",
  "events_calendar": "Calendrier des événements",
  "excerpt_summary": "Extrait / Résumé",
  "experimental": "Expérimental",
  "export": "Exporter",
  "export_data": "Exporter les données",
  "facebook": "Facebook",
  "facebook_login_unavailable": "Connexion Facebook indisponible",
  "failed_post_comment": "Échec de la publication du commentaire.",
  "feature_flags": "Drapeaux de fonctionnalité",
  "feature_job": "Emploi en vedette",
  "featured": "En vedette",
  "featured_article": "Article en vedette",
  "featured_duration": "Durée en vedette",
  "featured_image": "Image en vedette",
  "featured_jobs": "Offres en vedette",
  "feedback": "Retour",
  "filter": "Filtrer",
  "filter_terms_saved": "Termes de filtrage sauvegardés !",
  "find_jobs": "Trouver un emploi",
  "first": "Premier",
  "first_process_publish": "Traitez d'abord et publiez l'article",
  "footer_ai": "Ce portail utilise l",
  "footer_ai_notice": "Un contenu créé avec l'assistance de l'IA - signalez les problèmes",
  "footer_cat_business": "Affaires",
  "footer_cat_culture": "Culture",
  "footer_cat_health": "Santé",
  "footer_cat_news": "Actualités",
  "footer_cat_politics": "Politique",
  "footer_cat_sports": "Sports",
  "footer_cat_technology": "Technologie",
  "footer_categories": "Catégories",
  "footer_copyright": "2026 Liber Nostra d.o.o. Tous droits réservés.",
  "footer_description": "Croatia Times est votre source fiable pour les dernières nouvelles, les analyses approfondies et des histoires captivantes de Croatie et d'ailleurs.",
  "footer_developed_by": "Développé et maintenu avec amour par",
  "footer_email_placeholder": "Votre adresse e-mail",
  "footer_here": "ici",
  "footer_hosted_by": "Hébergé par",
  "footer_link_about": "À propos de nous",
  "footer_link_advertise": "Publicité",
  "footer_link_contact": "Contact",
  "footer_link_cookies": "Cookies",
  "footer_link_imprint": "Empreinte",
  "footer_link_privacy": "Politique de confidentialité",
  "footer_link_submit_news": "Soumettre des nouvelles",
  "footer_newsletter_text": "Abonnez-vous à notre newsletter",
  "footer_quick_links": "Liens rapides",
  "footer_stay_informed": "Restez informé",
  "footer_subscribe": "S'abonner",
  "for_you_personalized": "Contenu personnalisé en fonction de vos intérêts",
  "for_you_title": "Pour Vous",
  "forgot_password": "Mot de passe oublie?",
  "free": "Gratuit",
  "free_plan": "Gratuit",
  "from": "De",
  "full_time": "Temps plein",
  "general": "Général",
  "goodbye": "Au revoir",
  "hashtags": "Hashtags",
  "hashtags_placeholder": "#news #croatia...",
  "header_auto_schedule_active": "Planification automatique active",
  "header_forecast": "Prévision",
  "header_humidity": "Humidité",
  "header_live": "EN DIRECT",
  "header_portals_label": "Portails",
  "header_weather_humidity": "Humidité",
  "header_weather_wind": "Vent",
  "header_wind": "Vent",
  "health": "Sante",
  "hello": "Bonjour",
  "help": "Aide",
  "home": "Accueil",
  "home_podcast_title": "Résumé Tech Hebdomadaire : L'IA dans les Startups Croates",
  "home_video_title": "À l'intérieur de Zagreb : Documentaire sur le Street Art",
  "hours": "heures",
  "import": "Importer",
  "impressions": "Impressions",
  "imprint": "Mentions legales",
  "imprint_title": "Mentions légales",
  "inactive": "Inactif",
  "info": "Info",
  "instagram": "Instagram",
  "invalid_code": "Code invalide. Réessayez.",
  "items_selected": "éléments sélectionnés",
  "job_categories": "Categories d",
  "job_postings": "Offres d'emploi",
  "job_seeker": "Chercheur d",
  "jobs": "Emplois",
  "just_now": "À l'instant",
  "language": "Langue",
  "last": "Dernier",
  "latest_news": "Dernières nouvelles",
  "legal": "Juridique",
  "lifestyle": "Mode de vie",
  "lifetime": "À vie",
  "light_mode": "Mode clair",
  "linked_email_campaign": "Lié à une campagne d'emailing",
  "linkedin": "LinkedIn",
  "live_stream": "Diffusion en direct",
  "load_more": "Charger plus",
  "loading": "Chargement...",
  "local": "Local",
  "location": "Lieu",
  "login": "Connexion",
  "logout": "Deconnexion",
  "loyalty_available_points": "Points disponibles",
  "loyalty_available_rewards": "Récompenses disponibles",
  "loyalty_badges": "Insignes",
  "loyalty_consecutive_days": "Jours consécutifs",
  "loyalty_error": "Erreur",
  "loyalty_leaderboard": "Classement",
  "loyalty_leaderboard_empty": "Le classement est vide",
  "loyalty_rewards": "Récompenses",
  "loyalty_used_rewards": "Récompenses utilisées",
  "majstor_categories": "Catégories",
  "majstor_city": "Ville",
  "majstor_company_name": "Nom de l'entreprise *",
  "majstor_flexible": "Flexible",
  "majstor_max_budget": "Budget max (EUR)",
  "majstor_min_budget": "Budget min (EUR)",
  "majstor_my_requests": "Mes demandes",
  "majstor_request_title": "Titre de la demande *",
  "majstor_service_categories": "Catégories de services",
  "majstor_urgent": "Urgent",
  "manage": "Gérer",
  "manage_bookings": "Gérer les réservations d'annonceurs",
  "mark_as_read": "Marquer comme lu",
  "marketing_dashboard": "Tableau de Bord Marketing",
  "marketing_live_metrics": "Métriques de performance en direct pour Croatia Times",
  "marketing_published_articles": "Articles Publiés",
  "marketing_registered_users": "Utilisateurs Enregistrés",
  "marketing_today_views": "Vues d'aujourd'hui",
  "marketing_total_views": "Nombre total de vues",
  "minutes": "minutes",
  "missing_translations": "Traductions manquantes",
  "mobile": "Mobile",
  "more": "Plus",
  "most_popular": "Le plus populaire",
  "most_read": "Les plus lus",
  "move": "Déplacer",
  "must_be_logged_in_purchase": "Vous devez être connecté pour acheter un article",
  "myProfile": "Mon Profil",
  "my_applications": "Mes candidatures",
  "name": "Nom",
  "new": "Nouveau",
  "new_article": "Nouvel article",
  "new_campaign": "Nouvelle campagne",
  "new_notification": "Nouvelle notification",
  "new_push_notification": "Nouvelle notification push",
  "new_verification_sent": "Un nouveau code de vérification a été envoyé à votre email.",
  "news": "Actualites",
  "newsletter": "Newsletter",
  "newsletter_desc": "Abonnez-vous aux dernieres nouvelles",
  "newsletter_only_subscribers": "Seulement les abonnés",
  "newsletter_subscribers": "Abonnés à la newsletter",
  "next": "Suivant",
  "no": "Non",
  "noAccount": "Vous n'avez pas de compte ?",
  "no_articles": "Aucun article trouvé",
  "no_bookings": "Aucune réservation trouvée",
  "no_campaigns": "Aucune campagne",
  "no_data": "Aucune donnée disponible",
  "no_items": "Aucun élément trouvé",
  "no_linked_campaign": "Aucune campagne liée",
  "no_notifications": "Aucune notification",
  "no_results": "Aucun resultat",
  "no_scheduled_posts": "Pas encore de publications programmées",
  "no_sent_notifications": "Aucune notification envoyée",
  "none": "Aucun",
  "note": "Note",
  "notification_body": "Corps de la notification",
  "notification_title": "Titre de la notification",
  "notifications": "Notifications",
  "of": "de",
  "off": "Désactivé",
  "offline": "Hors ligne",
  "on": "Activé",
  "one_time": "unique",
  "online": "En ligne",
  "open_rate": "Taux d",
  "optional": "Optionnel",
  "options": "Options",
  "orContinueWith": "Ou continuer avec",
  "or_continue_with": "Ou continuer avec",
  "order": "Commande",
  "other": "Autre",
  "page": "Page",
  "part_time": "Temps partiel",
  "password": "Mot de passe",
  "paste": "Coller",
  "pause": "Pause",
  "payment_error": "Erreur de paiement",
  "payment_processing": "Traitement du paiement...",
  "payment_success": "Paiement reussi!",
  "payment_thank_you": "Merci pour votre achat !",
  "pending": "En attente",
  "pending_approval": "En attente d'approbation",
  "per_month": "/mois",
  "per_page": "par page",
  "percentage": "Pourcentage",
  "performance": "Performance",
  "phone": "Téléphone",
  "platforms": "Plateformes",
  "politics": "Politique",
  "poll_results": "Résultats",
  "poll_total_votes": "Votes totaux",
  "poll_vote": "Vote",
  "popular": "Populaire",
  "post_comment": "Publier un commentaire",
  "post_error": "Erreur de publication",
  "post_job": "Publier une offre",
  "post_now": "Publier maintenant",
  "powered_by": "Propulsé par",
  "premium": "Premium",
  "preview": "Aperçu",
  "previous": "Precedent",
  "price": "Prix",
  "privacy": "Confidentialite",
  "privacy_title": "Politique de confidentialité",
  "proceed_to_payment": "Procéder au paiement",
  "profile": "Profil",
  "profile_admin_access": "Accès Rapide Administrateur",
  "profile_analytics": "Analytique",
  "profile_articles": "Articles",
  "profile_dashboard": "Tableau de Bord",
  "profile_edit": "Modifier le Profil",
  "profile_verified": "Profil vérifié !",
  "promo_success": "Code promo appliqué avec succès !",
  "promote_job": "Promouvoir l'emploi",
  "publish": "Publier",
  "published": "Publie",
  "published_date": "Publié",
  "push_notifications": "Notifications push",
  "read": "Lire",
  "read_more": "Lire la suite",
  "real_estate": "Immobilier",
  "recent": "Recent",
  "recipes_add_first": "Ajoutez votre première recette",
  "recipes_browse_all": "Parcourir toutes les recettes",
  "recipes_category": "Catégorie",
  "recipes_cook_time": "Temps de Cuisson",
  "recipes_easy": "Facile",
  "recipes_featured": "Recettes en Vedette",
  "recipes_filters": "Filtres",
  "recipes_ingredient": "Ingrédient",
  "recipes_ingredients": "Ingrédients",
  "recipes_instructions": "Instructions",
  "recipes_latest": "Dernières Recettes",
  "recipes_most_popular": "Recettes les Plus Populaires",
  "recipes_prep_time": "Temps de Préparation",
  "recipes_search": "Rechercher des recettes...",
  "recipes_servings": "Portions",
  "recipes_title": "Recettes",
  "recommended": "Recommandé",
  "refresh": "Rafraîchir",
  "region": "Région",
  "register": "S",
  "reject": "Rejeter",
  "rejected": "Rejeté",
  "related_articles": "Articles connexes",
  "remote": "Teletravail",
  "remove": "Supprimer",
  "report": "Rapport",
  "reports": "Rapports",
  "reposting_rules_title": "Règles de republication",
  "required": "Requis",
  "reset": "Réinitialiser",
  "restore": "Restaurer",
  "results": "Resultats",
  "resume": "Reprendre",
  "revision_restored": "Révision restaurée !",
  "salary": "Salaire",
  "salary_max": "Salaire Max",
  "salary_min": "Salaire minimum",
  "save": "Enregistrer",
  "saved_jobs": "Offres enregistrees",
  "saved_successfully": "Enregistré avec succès",
  "schedule": "Horaire",
  "scheduled": "Planifié",
  "science": "Science",
  "search": "Rechercher...",
  "search_articles": "Rechercher des articles...",
  "search_placeholder": "Rechercher...",
  "search_results_for": "Résultats de recherche pour",
  "seconds": "secondes",
  "see_all": "Voir tout",
  "select": "Sélectionner",
  "select_all": "Tout sélectionner",
  "select_format": "Sélectionnez le format",
  "seller": "Vendeur",
  "send_campaign": "Envoyer la campagne",
  "sent": "Envoyé",
  "sent_campaigns": "Campagnes envoyées",
  "services": "Services",
  "settings": "Paramètres",
  "share": "Partager",
  "showing": "Affichage",
  "signIn": "Connexion",
  "signOut": "Déconnexion",
  "site_name": "Croatia Times",
  "site_subtitle": "Croatie Aujourd",
  "six_digit_code": "Code à 6 chiffres",
  "social_media": "Réseaux sociaux",
  "social_scheduler": "Planificateur social",
  "sort": "Trier",
  "sponsored_marketplace_title": "Marché Sponsorisé",
  "sports": "Sports",
  "stable": "Stable",
  "start": "Commencer",
  "start_date": "Date de début",
  "static_about_contact": "Pour les demandes éditoriales, la publicité ou des informations générales, visitez notre",
  "static_about_contact_page": "page de contact",
  "static_about_contact_title": "Contact",
  "static_about_lead": "Croatia Times est un portail d'informations indépendant qui vous apporte les dernières nouvelles, analyses, commentaires et histoires de Croatie et de la région. Nous faisons partie de la famille médiatique e-mina.eu, avec la même équipe et les mêmes valeurs.",
  "static_about_mission": "Nous sommes dédiés à fournir un journalisme précis, opportun et de qualité qui sert l'intérêt public. Notre équipe éditoriale est composée de journalistes expérimentés ayant une connaissance approfondie des affaires croates et régionales.",
  "static_about_mission_title": "Notre Mission",
  "static_about_publisher": "Liber Nostra d.o.o. est l'éditeur de Croatia Times et e-mina.eu. La société est spécialisée dans les médias numériques et les portails d'information axés sur le marché croate.",
  "static_about_publisher_title": "Éditeur",
  "static_about_standards": "Croatia Times adhère aux normes journalistiques les plus élevées. Nous vérifions nos rapports, étiquetons clairement commentaires et analyses, et corrigeons rapidement et de manière transparente les erreurs.",
  "static_about_standards_title": "Normes Éditoriales",
  "static_about_team": "Derrière Croatia Times se trouve une équipe de professionnels des médias expérimentés, journalistes, éditeurs et experts techniques qui travaillent au développement de la plateforme et à la qualité du contenu. Notre équipe est la même que derrière le portail réussi e-mina.eu - Agence de Presse Internationale.",
  "static_about_team_title": "Équipe",
  "static_about_title": "À Propos de Nous - Croatia Times",
  "static_bug_description": "Description du Bug",
  "static_bug_description_placeholder": "Décrivez ce qui s'est passé et comment reproduire le problème...",
  "static_bug_intro": "Vous avez trouvé quelque chose qui ne fonctionne pas correctement ? Faites-le nous savoir et nous le corrigerons rapidement.",
  "static_bug_page_url": "URL de la page (où le bug s'est produit)",
  "static_bug_screenshot": "Capture d'écran (facultatif)",
  "static_bug_submit": "Soumettre le Rapport de Bug",
  "static_bug_submitting": "Soumission...",
  "static_bug_thanks": "Merci pour votre rapport ! Nous enquêterons et corrigerons le problème.",
  "static_bug_title": "Signaler un Bug",
  "static_commenting_intro": "Nous apprécions les discussions constructives. Pour que notre section de commentaires reste positive et productive, veuillez suivre ces règles :",
  "static_commenting_login": "Pour commenter, vous devez être enregistré et connecté à Croatia Times.",
  "static_commenting_rule_1": "Soyez respectueux et courtois envers les autres utilisateurs et les sujets des articles",
  "static_commenting_rule_2": "Pas de discours haineux, de racisme, de sexisme ou de discrimination de quelque nature que ce soit",
  "static_commenting_rule_3": "Aucune publicité, spam ou contenu promotionnel",
  "static_commenting_rule_4": "Pas de désinformation ou de diffusion de déclarations non vérifiées",
  "static_commenting_rule_5": "Pas d'attaques personnelles ni de harcèlement",
  "static_commenting_rule_6": "Restez sur le sujet et contribuez à la conversation",
  "static_commenting_rule_7": "Pas d'informations personnelles ou confidentielles sur des tiers",
  "static_commenting_title": "Règles de commentaire",
  "static_commenting_violation": "Les commentaires qui enfreignent ces règles peuvent être supprimés sans préavis. Les récidivistes peuvent être bannis définitivement.",
  "static_contact_email": "Email",
  "static_contact_message": "Message",
  "static_contact_message_placeholder": "Votre message...",
  "static_contact_name": "Nom",
  "static_contact_name_placeholder": "Votre nom",
  "static_contact_send": "Envoyer le Message",
  "static_contact_sending": "Envoi...",
  "static_contact_sent_desc": "Nous vous répondrons dans les 24 heures.",
  "static_contact_sent_title": "Message Envoyé !",
  "static_contact_subject": "Objet",
  "static_contact_subject_placeholder": "Comment pouvons-nous aider ?",
  "static_contact_title": "Contactez-Nous",
  "static_cookies_advertising_text": "Nous pouvons utiliser des cookies Google AdSense pour diffuser des publicités pertinentes.",
  "static_cookies_advertising_title": "Cookies publicitaires",
  "static_cookies_analytics_text": "Google Analytics nous aide à comprendre comment les visiteurs utilisent notre site. Les données sont anonymisées dans la mesure du possible.",
  "static_cookies_analytics_title": "Cookies d'analyse",
  "static_cookies_managing_text": "Vous pouvez contrôler les cookies via les paramètres de votre navigateur. Désactiver les cookies nécessaires peut affecter la fonctionnalité du site.",
  "static_cookies_managing_title": "Gestion des cookies",
  "static_cookies_necessary_text": "Ils sont nécessaires pour que le site fonctionne (sessions de connexion, préférences de thème). Ils ne peuvent pas être désactivés.",
  "static_cookies_necessary_title": "Cookies nécessaires",
  "static_cookies_title": "Politique de cookies",
  "static_cookies_types_title": "Types de cookies que nous utilisons",
  "static_cookies_what_text": "Les cookies sont de petits fichiers texte placés sur votre appareil lorsque vous visitez un site web. Ils aident le site à se souvenir de vos préférences et à comprendre comment vous l'utilisez.",
  "static_cookies_what_title": "Que sont les cookies",
  "static_imprint_ads_email": "Email (publicité) :",
  "static_imprint_ai_notice": "Certains contenus sont générés à l'aide de la technologie IA. Signaler les erreurs ou contenus inappropriés à",
  "static_imprint_contact": "Contact",
  "static_imprint_copyright": "Droits d'Auteur",
  "static_imprint_copyright_text": "Tout le contenu publié sur Croatia Times est protégé par des droits d'auteur. Liber Nostra d.o.o. conserve tous les droits sur le texte, les images et le contenu multimédia publiés sur ce site. Des informations détaillées sur les règles de republication de contenu sont disponibles sur la",
  "static_imprint_ct_desc": "Portail d'actualités Croatia Times",
  "static_imprint_disclaimer": "Avertissement",
  "static_imprint_disclaimer_text": "Malgré un contrôle rigoureux du contenu, nous n'assumons aucune responsabilité pour les liens externes. Leurs opérateurs sont seuls responsables de leur contenu.",
  "static_imprint_editorial_email": "Email (éditorial) :",
  "static_imprint_emina_desc": "Agence de Presse Internationale",
  "static_imprint_general_email": "Email (renseignements généraux) :",
  "static_imprint_last_updated": "Dernière mise à jour : Février 2026",
  "static_imprint_or_via": "ou via notre",
  "static_imprint_publisher": "Éditeur",
  "static_imprint_registered": "Enregistré en République de Croatie",
  "static_imprint_reposting_page": "page des Règles de Republication",
  "static_imprint_responsible": "Responsable du Contenu",
  "static_imprint_responsible_text": "Équipe éditoriale de Croatia Times / Liber Nostra d.o.o.",
  "static_imprint_title": "Mentions Légales",
  "static_imprint_websites": "Sites Web",
  "static_privacy_controller": "Responsable du traitement des données : Liber Nostra d.o.o.",
  "static_privacy_cookies_text": "Nous utilisons des cookies pour la fonctionnalité et l'analyse. Consultez notre politique de cookies pour plus de détails.",
  "static_privacy_cookies_title": "Cookies",
  "static_privacy_data_text": "Nous collectons les données que vous fournissez directement (nom, email lors de l'inscription), les données d'utilisation (pages visitées, articles lus) et les données techniques (adresse IP, type de navigateur).",
  "static_privacy_data_title": "Données que Nous Collectons",
  "static_privacy_last_updated": "Dernière mise à jour : janvier 2026",
  "static_privacy_lead": "Croatia Times respecte votre vie privée et s'engage à protéger vos données personnelles.",
  "static_privacy_retention_text": "Nous conservons vos données aussi longtemps que votre compte est actif, ou si nécessaire à des fins légales.",
  "static_privacy_retention_title": "Conservation des données",
  "static_privacy_rights_text": "Vous avez le droit d'accéder à vos données personnelles, de les corriger ou de les supprimer. Contactez-nous à",
  "static_privacy_rights_title": "Vos droits",
  "static_privacy_title": "Politique de Confidentialité",
  "static_privacy_usage_text": "Nous utilisons vos données pour fournir notre service d'actualités, personnaliser votre expérience, envoyer des newsletters (avec votre consentement) et améliorer notre plateforme.",
  "static_privacy_usage_title": "Comment Nous Utilisons Vos Données",
  "static_reposting_copyright_text": "Tout le contenu publié sur Croatia Times est protégé par le droit d'auteur. Liber Nostra d.o.o. conserve tous les droits sur les textes, images et multimédias publiés sur ce site.",
  "static_reposting_copyright_title": "Droits d'auteur",
  "static_reposting_permission_text": "Pour obtenir l'autorisation de réimprimer du contenu, contactez-nous à",
  "static_reposting_permission_title": "Demandes d'autorisation",
  "static_reposting_permitted_text": "Vous pouvez partager des liens vers nos articles sur les réseaux sociaux et autres plateformes. De courts extraits (jusqu'à 2 paragraphes) peuvent être utilisés avec une attribution claire et un lien vers l'article original.",
  "static_reposting_permitted_title": "Utilisation autorisée",
  "static_reposting_prohibited_text": "La réimpression complète des articles sans autorisation écrite est interdite. Les images ne peuvent pas être reproduites sans autorisation. Le scraping automatique de contenu est strictement interdit.",
  "static_reposting_prohibited_title": "Utilisation interdite",
  "static_reposting_title": "Règles de republication",
  "static_submit_news_details": "Détails de l'histoire",
  "static_submit_news_details_placeholder": "Décrivez les actualités...",
  "static_submit_news_file_limit_error": "Le fichier dépasse la limite de",
  "static_submit_news_headline": "Titre de l'actualité",
  "static_submit_news_intro": "Vous avez des nouvelles ? Envoyez-les ici et notre équipe éditoriale les examinera.",
  "static_submit_news_limit": "Nous acceptons les photos et les vidéos jusqu'à",
  "static_submit_news_photos": "Photos / Vidéo (jusqu'à",
  "static_submit_news_send": "Soumettre une Actualité",
  "static_submit_news_sending": "Envoi...",
  "static_submit_news_source": "Source / Référence (optionnel)",
  "static_submit_news_source_placeholder": "URL ou référence",
  "static_submit_news_thanks": "Merci pour votre soumission ! Notre équipe l'examinera sous peu.",
  "static_submit_news_title": "Soumettez vos nouvelles",
  "static_submit_news_your_name": "Votre nom",
  "status": "Statut",
  "stop": "Arrêter",
  "submit": "Soumettre",
  "submitNews": "Soumettre des nouvelles",
  "submit_bug_title": "Soumettre un rapport de bug",
  "submit_news": "Soumettre une info",
  "submit_news_title": "Soumettre une actualité",
  "subscribe": "S",
  "subscription": "Abonnement",
  "subscription_title": "Plans d'Abonnement",
  "success": "Succes",
  "support": "Assistance",
  "tablet": "Tablette",
  "tags": "Tags",
  "target_impressions": "Ciblage des impressions",
  "technology": "Technologie",
  "template": "Modèle",
  "templates": "Modèles",
  "terms": "Conditions",
  "thank_you": "Merci",
  "this_month": "Ce mois-ci",
  "this_week": "Cette semaine",
  "this_year": "Cette année",
  "tip": "Conseil",
  "title": "Titre",
  "to": "À",
  "today": "Aujourd'hui",
  "total": "Total",
  "translate_all": "Traduire tout",
  "translation_status": "Statut de la traduction",
  "translations": "Traductions",
  "travel": "Voyage",
  "trending": "Tendance",
  "try_again": "Reessayer",
  "twitter": "Twitter",
  "two_factor_auth": "Authentification à deux facteurs",
  "type": "Type",
  "ugc_submit": "Soumettre du Contenu",
  "ugc_title": "Portail de Journalisme Citoyen",
  "unique_clicks": "Clics uniques",
  "unique_opens": "Ouvertures uniques",
  "unknown": "Inconnu",
  "unpublish": "Dépublier",
  "unread": "Non lu",
  "update": "Mettre à jour",
  "updated_successfully": "Mis à jour avec succès",
  "upgrade": "Ameliorer",
  "upload": "Téléverser",
  "users": "Utilisateurs",
  "vehicles": "Véhicules",
  "verification_code_sent": "Code de vérification envoyé à votre email !",
  "version": "Version",
  "vibeposao": "Times Posao",
  "view": "Voir",
  "view_all": "Voir tout",
  "views": "Vues",
  "warning": "Avertissement",
  "welcome": "Bienvenue",
  "wish_roles": "Postes souhaites",
  "working_hours_saved": "Horaires de travail sauvegardés !",
  "world": "Monde",
  "write_new_article": "Écrire un nouvel article",
  "yes": "Oui",
  "yesterday": "Hier",
  "your_bookings": "Vos réservations",
  "youtube": "YouTube"
}
